import { Link } from "react-router-dom";
import { LogoMark } from "@/components/Logo";
import { useCookieConsent } from "@/components/CookieConsentContext";

export default function SiteFooter() {
  const { setSettingsOpen } = useCookieConsent();

  return (
    <footer className="no-print px-5 py-8 text-sm text-[#7a6c5e] max-w-6xl mx-auto w-full flex flex-wrap gap-4 justify-between">
      <span className="inline-flex items-center gap-2"><LogoMark size={20} /> © En Dos Mundos · endosmundos.com</span>
      <nav aria-label="Enlaces legales" className="flex flex-wrap gap-x-5 gap-y-2">
        <Link to="/politica-de-privacidad" data-testid="footer-privacy-link" className="hover:underline">Política de privacidad</Link>
        <Link to="/aviso-legal" data-testid="footer-legal-notice-link" className="hover:underline">Aviso legal</Link>
        <Link to="/politica-de-cookies" data-testid="footer-cookie-policy-link" className="hover:underline">Política de cookies</Link>
        <Link to="/condiciones-de-compra" data-testid="footer-purchase-terms-link" className="hover:underline">Condiciones de compra</Link>
        <a href="mailto:endosmundos.digital@gmail.com" data-testid="footer-contact-link" className="hover:underline">Contacto</a>
        <Link to="/taller-rabietas-2-3" data-testid="footer-rabietas-link" className="hover:underline">Taller de rabietas</Link>
        <button type="button" data-testid="footer-cookie-settings-button" onClick={() => setSettingsOpen(true)} className="hover:underline">Configurar cookies</button>
        <Link to="/acceder" data-testid="footer-access-link" className="hover:underline">Acceder a mi pack</Link>
      </nav>
    </footer>
  );
}